export interface SummaryCoupon {
  percent_off?: string | number | null
  amount_off?: string | number | null
  duration?: string
  duration_in_months?: number | null
}

export function getDiscountLabel(coupon: SummaryCoupon): string {
  const amountOff = Number(coupon.amount_off)
  const amountLabel = coupon.percent_off
    ? `${Number(coupon.percent_off)}% off`
    : `$${Number.isInteger(amountOff) ? amountOff : amountOff.toFixed(2)} off`
  const months = coupon.duration_in_months
  if (coupon.duration !== 'repeating' || !months) {
    return amountLabel
  }
  return `${amountLabel} for ${months === 1 ? '1 month' : `${months} months`}`
}

function roundToCents(amount: number): number {
  return Math.round(amount * 100) / 100
}

export function formatMoney(amount: number): string {
  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `$${formatted}`
}

export function getDiscountAmount(planAmount: number, coupon?: SummaryCoupon | null): number {
  if (!coupon) {
    return 0
  }
  if (coupon.amount_off) {
    return Math.min(Number(coupon.amount_off), planAmount)
  }
  if (coupon.percent_off) {
    return roundToCents((Number(coupon.percent_off) / 100) * planAmount)
  }
  return 0
}



// WEBPACK FOOTER //
// ./src/components/SubscriptionSummary/utils.ts